export default "__VITE_ASSET__c451cacd__"